// Pure helpers for the Auditor tab's human rulings (phase 3,
// docs/qa-observer.md "Human rulings"). The ruling is blind: the page shows
// the auditor's answer only after the person submits, and the server
// enforces it. No free text is sent: every field is a fixed value.

export const SOLVED_LABEL = { yes: 'Yes, solved', no: 'No, not solved', unknown: "Can't tell" }

export const PART_LABEL = {
  ai_draft: 'The AI draft',
  proposed_action: 'The proposed action',
  rep: 'The rep',
  process: 'The process',
  other: 'Other',
  unknown: 'Unknown',
}

export const EXCEPTION_LABEL = {
  policy_exception: 'A policy exception',
  customer_specific: 'Specific to this customer',
  facts_missing: 'Facts were missing',
  other: 'Other',
}

// The form -> the POST body, or { error } when it is not complete.
export function rulingRequest(convNumber, form) {
  if (!SOLVED_LABEL[form?.solved]) return { error: 'Choose whether the problem was solved.' }
  const body = { convNumber: Number(convNumber), solved: form.solved }
  if (form.solved === 'no' && form.failedPart) {
    if (!PART_LABEL[form.failedPart] || form.failedPart === 'unknown') return { error: 'Choose a part.' }
    body.failedPart = form.failedPart
  }
  if (form.exception) {
    if (!EXCEPTION_LABEL[form.exceptionReason]) return { error: 'Choose why this case is an exception.' }
    body.exception = true
    body.exceptionReason = form.exceptionReason
  }
  return { body }
}

// What to tell the person when a ruling is refused.
export function rulingErrorMessage(err) {
  const code = err?.body?.error
  if (err?.status === 403 && code === 'rulings_not_granted') return 'Rulings are not enabled yet: the auditor has not granted CXHub the ruling_writer role.'
  if (err?.status === 404 && code === 'rulings_off') return 'Rulings are not enabled in this environment (QA_OBSERVER_RULINGS_ENABLED).'
  if (err?.status === 409) return 'You have already ruled on this contact. A ruling is locked once submitted.'
  if (err?.status === 404 && code === 'not_sampled') return 'This contact is not in the sample.'
  if (err?.status === 400) return `The ruling was refused (${code ?? 'bad request'}).`
  return 'The auditor could not be reached. Try again.'
}

export function pct(v) {
  return v == null ? '—' : `${Math.round(v * 100)}%`
}

// One week's agreement as a sentence: the number and its sample size.
export function agreementLine(w) {
  if (!w || !w.counted) return 'No counted rulings yet.'
  return `${pct(w.agreement)} (${w.agreed} of ${w.counted} rulings)`
}
